<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-rrhh-discounts'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-rrhh-discounts"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="id"
          :empty-text="$t('No matching records found')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(business_name)="data">
            <span> {{ data.value }} </span>
          </template>

          <template #cell(status)="data">
            <b-badge
              :variant="
                data.item.status == 1 ? 'light-success' : 'light-danger'
              "
            >
              <span>
                {{ data.item.status == 1 ? $t("Active") : $t("Inactive") }}
              </span>
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <feather-icon
              icon="EditIcon"
              class="text-warning cursor-pointer"
              size="17"
              @click="editClient(data.item)"
            />

            <feather-icon
              icon="Trash2Icon"
              class="text-danger cursor-pointer ml-1"
              size="17"
              @click="inactiveClient(data.item)"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <ClientsModal
      v-if="clientModal"
      :clientId="clientId"
      @hideModal="clientModal = false"
      @registered="
        $refs['ref-table-rrhh-discounts'].refresh();
        clientModal = false;
      "
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Fields from "@/views/commons/clients/data/Fields.data.js";
import Filters from "@/views/commons/clients/data/Filters.data.js";

import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

import ClientsService from "@/views/commons/clients/services/clients.service.js";
import ClientsModal from "@/views/commons/clients/components/modals/ClientsModal.vue";

export default {
  components: {
    FilterSlot,
    ClientsModal,
  },
  data() {
    return {
      filters: Filters,
      params: 1,
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      clientModal: false,
      clientId: null,
    };
  },
  async created() {
    this.addPreloader();
    await this.getDocumentTypes();
    this.removePreloader();
  },
  computed: {
    showFields() {
      //   this.fields.map((row) => (row.visible = true));
      return this.fields.filter((item) => item.visible);
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  methods: {
    async myProvider(ctx) {
      try {
        let order = 2;
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: 1,
          from: this.filters[0].model,
          to: this.filters[1].model,
          documentType: this.filters[2].model
        };
        const { data } = await ClientsService.getClients(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },

    newClient() {
      this.clientId = null;
      this.clientModal = true;
    },

    editClient(item) {
      this.clientId = item.id;
      this.clientModal = true;
    },

    async inactiveClient(item) {
      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();
        const data = await ClientsService.inactiveClient({
          client_id: item.id,
        });

        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$refs["ref-table-rrhh-discounts"].refresh();
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },
    async getDocumentTypes(){
      const { data } = await ClientsService.getDocumentTypes();
      this.filters[2].options = data;
    }
  },
};
</script>

<style>
</style>